import { defineStore } from 'pinia'
import type { PolicyDocument } from '~/composables/usePrivacyPolicy'

type OnAgreeCallback = (documentId: number) => void
type OnDeclineCallback = () => void

export const usePrivacyPolicyModalStore = defineStore('privacyPolicyModal', {
  state: () => ({
    isOpen: false,
    closeable: true,
    wasAgreed: false,
    preloadedDoc: null as PolicyDocument | null,
    _onAgree: null as OnAgreeCallback | null,
    _onDecline: null as OnDeclineCallback | null
  }),

  actions: {
    open(options: { closeable?: boolean; doc?: PolicyDocument; onAgree: OnAgreeCallback; onDecline?: OnDeclineCallback }) {
      this.closeable = options.closeable ?? true
      this.wasAgreed = false
      this.preloadedDoc = options.doc ?? null
      this._onAgree = options.onAgree
      this._onDecline = options.onDecline ?? null
      this.isOpen = true
    },

    agree(documentId: number) {
      this.wasAgreed = true
      this._onAgree?.(documentId)
      this.isOpen = false
    },

    decline() {
      this._onDecline?.()
      this.isOpen = false
    },

    close() {
      if (!this.closeable) {
        this.decline()
        return
      }
      this.isOpen = false
    }
  }
})
